import NavBar from "../components/Navbar/NavBar"
import { Helper } from "../static/helper"
import Footer from "../components/Footer"
import ScrollToTop from '../components/ScrollToTop';

export const Chiropraxie = () => {

    const webSite = () => {
        window.open(Helper.urlReservation)
    }

    return <>
        <div>
            <NavBar />
        </div>

        <ScrollToTop>

        <div className="min-h-screen bg-gray-50">
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pt-24 lg:pt-32 pb-12">

                <div className="bg-white rounded-2xl shadow-xl p-6 sm:p-8 lg:p-12">
                    <h1 style={{ color: Helper.footerBackGroundColor }} className="font-bold text-2xl sm:text-3xl lg:text-4xl text-center mb-8">
                        Qu'est-ce que la Chiropraxie ?
                    </h1>

                    <div className="space-y-6 text-gray-600 text-base sm:text-lg leading-relaxed">
                        <p>
                            La chiropraxie se distingue par une <strong className="text-gray-800">approche globale</strong>, qui intègre l'histoire personnelle et médicale de chaque patient, ainsi que ses antécédents familiaux, ses habitudes de vie et son environnement professionnel.
                        </p>

                        <p>
                            Cette profession est reconnue depuis <strong className="text-gray-800">2002 en France</strong> et dans plus de 40 autres pays à travers le monde. Profession manuelle de référence pour le traitement du dos et des articulations, la chiropraxie se classe comme la <strong className="text-gray-800">troisième profession de santé aux États-Unis</strong>.
                        </p>

                        <div className="bg-gray-50 rounded-xl p-6 my-8">
                            <p className="text-gray-700">
                                En tant que <strong>thérapeute de première intention</strong>, le chiropracteur peut être consulté directement, sans passer par un médecin traitant. Il est formé pour offrir une prise en charge adaptée et orienter les patients vers un médecin si un avis médical est nécessaire.
                            </p>
                        </div>

                        <p>
                            La chiropraxie est une profession réglementée, et le titre de chiropracteur est réservé aux professionnels ayant obtenu un diplôme reconnu par le ministère de la Santé. En France, ce diplôme est délivré exclusivement par l'<strong className="text-gray-800">Institut Franco-Européen de Chiropraxie (IFEC)</strong> après cinq années d'études à temps plein.
                        </p>
                    </div>

                    <div className="flex justify-center mt-10">
                        <button style={{ background: Helper.footerBackGroundColor }} className="text-white font-semibold px-8 py-4 rounded-xl shadow-lg hover:opacity-90 transition-opacity" onClick={webSite}>
                            Prendre rendez-vous
                        </button>
                    </div>
                </div>

            </div>
        </div>

        <Footer />

        </ScrollToTop>
    </>
}
